import clsx from 'clsx';
import { RefObject } from 'react';

import { useOpenTriggerState } from 'hooks/useOpenTrigger';

import { MenuMobile } from 'components/sidebar-menu';

import styles from './styles.module.css';

export interface Props {
  state?: useOpenTriggerState;
  triggerRef?: RefObject<any>;
}

export const MenuContent = ({ state }: Props) => {
  let { isOpen } = state as useOpenTriggerState;

  const menuBodyClasses = clsx(styles.menuBody, {
    [styles.menuBodyActive]: isOpen,
  });

  return (
    <div className={menuBodyClasses}>
      <MenuMobile />
    </div>
  );
};
